<template>
	<div id="BlogDate">
		<el-calendar v-model="value" class="calendar">
			<template slot="dateCell" slot-scope="{ data }"><div class="date-cell" @click="selectDay(data.day)"><span>{{ data.day.split('-').slice(2).join('') }}</span><b v-if="count(data.day)">{{ count(data.day) }} 篇</b></div></template>
		</el-calendar>
		<el-card v-if="selected.length" class="daily-list"><b>{{ activeDay }} 发布</b><a v-for="item in selected" :key="item.publicId" :href="'/essay/'+item.publicId">{{ item.subject }}</a></el-card>
	</div>
</template>

<script>
	 import { getCalendar } from '@/api/essay/essay'
	 export default {
		data() {
		  return {
			value: new Date(), items: [], activeDay: '', selected: []
		  }
		}, created(){ this.load() }, watch:{ value(){this.load()} }, methods:{ load(){ const m=this.value.toISOString().slice(0,7); getCalendar(m).then(r=>{this.items=r.data.data||[]}) }, count(day){return this.items.filter(x=>x.releaseTime&&x.releaseTime.slice(0,10)===day).length}, selectDay(day){this.activeDay=day;this.selected=this.items.filter(x=>x.releaseTime&&x.releaseTime.slice(0,10)===day)} }
	  }
</script>

<style scoped>
	#BlogDate {
		margin-top: 20px;
		width: 350px;
		position: relative;
	}
	
	/deep/ .el-calendar { border:1px solid #ded4c4; background:#fffdf8; }
	/deep/ .el-calendar__header { border-bottom:1px solid #ded4c4; color:#4a3528; }
	/deep/ .el-calendar-table .el-calendar-day {
		box-sizing: border-box;
		padding: 4px;
		height: 54px;
	}
	.date-cell{height:100%;display:flex;flex-direction:column;justify-content:space-between;color:#4a3528}.date-cell b{font-size:11px;color:#9a6237;font-weight:500}.daily-list{margin-top:10px;border-color:#ded4c4}.daily-list a{display:block;color:#714827;margin-top:8px;text-decoration:none;font-size:13px}.daily-list a:hover{text-decoration:underline}
</style>
